import { render } from "./TrialPage.vue?vue&type=template&id=45655b8f&scoped=true"
import script from "./TrialPage.vue?vue&type=script&lang=js"
export * from "./TrialPage.vue?vue&type=script&lang=js"

import "./TrialPage.vue?vue&type=style&index=0&id=45655b8f&lang=css"
import "./TrialPage.vue?vue&type=style&index=1&id=45655b8f&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45655b8f"]])

export default __exports__